webpackJsonp([18],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function (_value) {
  if (!arguments.length) return this.__attrs__.sortByValue;
  if (typeof _value !== 'string' || !__WEBPACK_IMPORTED_MODULE_0__index__["b" /* orders */].find(function (o) {
    return o === _value;
  })) {
    _value = 'natural';
  }
  this.__attrs__.sortByValue = _value;
  return this;
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default___ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_error__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_transform__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(59);





function _munge() {
  var _this = this;

  //데이터 갱신시
  //TODO: Limit 기능 이용해서 dimension의 unique한 개수 조절

  var conditionFunc = function conditionFunc(dimensions, measures) {
    var field = this.__execs__.field;
    if (dimensions.length <= 2 && measures.length === 0) {
      if (dimensions.length === 2) {
        field.region = dimensions[0];
        field.x = dimensions[1];
      } else {
        field.x = dimensions[0];
      }
      this.measure(__WEBPACK_IMPORTED_MODULE_0__default___["b" /* countMeasure */]); //count 모드일때는 가짜 measure 추가
      field.y = measures[0];
      return __WEBPACK_IMPORTED_MODULE_3____["a" /* conditions */][1];
    } else if (dimensions.length <= 2 && measures.length === 1) {
      if (dimensions.length === 2) {
        field.region = dimensions[0];
        field.x = dimensions[1];
      } else {
        field.x = dimensions[0];
      }
      field.y = measures[0];
      return __WEBPACK_IMPORTED_MODULE_3____["a" /* conditions */][0];
    } else if (dimensions.length <= 1 && measures.length >= 2) {
      if (dimensions.length === 1) {
        field.region = dimensions[0];
        field.x = this.mixedDimension();
      } else {
        field.x = this.mixedDimension();
      }
      field.y = __WEBPACK_IMPORTED_MODULE_0__default___["e" /* mixedMeasure */];
      return __WEBPACK_IMPORTED_MODULE_3____["a" /* conditions */][2];
    } else throw new __WEBPACK_IMPORTED_MODULE_1__modules_error__["a" /* ConditionException */]();
  };
  this.condition(conditionFunc); // condiion 설정
  var field = this.__execs__.field;
  var mixed = this.isMixed();

  if (this.aggregated()) {
    this.__execs__.munged = [this.data().copy()];
  } else if (mixed) {
    this.__execs__.munged = this.aggregateMixed(this.facet() && !this.stacked()); //가짜 dimension과 measure로 처리
  } else {
    this.__execs__.munged = this.aggregate(this.facet() && !this.stacked());
    if (!this.isNested()) this.__execs__.munged = [this.__execs__.munged[0].parent];
  }

  if (this.stacked()) {
    // mixed 아닐때는 동일
    if (!field.region) {
      Object(__WEBPACK_IMPORTED_MODULE_2__modules_transform__["c" /* stack */])(this.__execs__.munged, field.y, mixed, this.normalized());
    } else {
      //TODO: 2번째 dimension의 개수가 동일한지 확인
      var domain = void 0; // 첫번째 순서에 맞추도록
      this.__execs__.munged.forEach(function (d, i) {
        if (field.x.order === 'natural') {
          if (i === 0) domain = d.children.map(function (d) {
            return d.data.key;
          });else d.children.sort(Object(__WEBPACK_IMPORTED_MODULE_2__modules_transform__["a" /* comparator */])('ascending', domain, true, function (d) {
            return d.data.key;
          }));
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__modules_transform__["c" /* stack */])(d.children, field.y, mixed, _this.normalized());
      });
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (_munge);

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_transform__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default___ = __webpack_require__(2);




function _scale() {
  var scale = this.scale();
  var munged = this.__execs__.munged;
  var nested = this.isNested();
  var stacked = this.stacked();
  var facet = this.facet();
  var aggregated = this.aggregated();
  var mixed = this.isMixed();
  var field = this.__execs__.field;
  var xAt = this.axisX();
  var yAt = this.axisY();
  var yDomain = void 0,
      xDomain = void 0;
  var regionDomain = void 0;

  scale.x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleBand */])().padding(this.padding());
  scale.y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* scaleLinear */])();

  if (nested) {
    regionDomain = __WEBPACK_IMPORTED_MODULE_2__default___["d" /* default */].ordinalDomain(munged, 0, null, field.region.order);
    scale.region = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleBand */])().domain(regionDomain).padding(this.regionPadding());
  }

  if (this.isFacet()) {
    //facet인 경우 dimension의 순서를 바꿔서 aggregate 되어있음
    //TODO: regionDomain 가지고 thickness 구하기
    scale.region = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleBand */])().domain(regionDomain).padding(this.regionPadding());
    scale.color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scaleOrdinal */])().domain(regionDomain).range(this.color());

    if (facet.orient === 'horizontal' && xAt) {
      xAt.orient = 'top';
      xAt.showDomain = false;
      this.thickness(xAt, scale.region, true, true);
      if (yAt) yAt.thickness = 0;
    } else if (facet.orient === 'vertical' && yAt) {
      yAt.orient = 'right';
      yAt.showDomain = false;
      this.thickness(yAt, scale.region, false, true);
      if (xAt) xAt.thickness = 0;
    }

    var _innerSize = this.innerSize();
    if (facet.orient === 'vertical') {
      scale.region.rangeRound([0, _innerSize.height]);
    } else {
      scale.region.rangeRound([0, _innerSize.width]);
    }
    return;
  }
  var level = 1;
  if (!nested && this.sortByValue() !== 'natural') {
    //sortByValue 인 경우 처리 
    var order = this.sortByValue();
    var yField = this.measureName();
    var result = munged[0].children.map(function (d) {
      return { key: d.data.key, value: d.data.value[yField] };
    });
    xDomain = result.sort(Object(__WEBPACK_IMPORTED_MODULE_1__modules_transform__["a" /* comparator */])(order, [], false, function (d) {
      return d.value;
    })).map(function (d) {
      return d.key;
    });
  } else {
    xDomain = __WEBPACK_IMPORTED_MODULE_2__default___["d" /* default */].ordinalDomain(munged, level, null, field.x.order);
  }
  yDomain = __WEBPACK_IMPORTED_MODULE_2__default___["d" /* default */].continousDomain(munged, field.y, level, mixed, stacked, aggregated);

  if (nested || !nested && (this.mono() === false || stacked)) {
    //nested
    scale.color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scaleOrdinal */])().domain(xDomain).range(this.color());
  }

  // bar-chart 의 경우 시작점을 0으로 맞춤
  if (yDomain[0] > 0) yDomain[0] = 0;else if (yDomain[1] < 0) yDomain[1] = 0;

  if (this.showDiff() && !nested) {
    if (yDomain[0] === 0) yDomain[1] *= 1.25;else if (yDomain[1] === 0) yDomain[0] *= 1.25;
  }
  if (stacked) {
    if (!nested) {
      scale.x.domain([field.x.field]);
    }
  } else {
    //not stacked
    scale.x.domain(xDomain);
  }
  this.setCustomDomain('y', yDomain);
  //scale.x에 대한 customDomain 처리

  var targetXField = nested ? field.region : field.x;

  if (this.isVertical()) {
    //vertical
    if (targetXField.interval && targetXField.format) xAt.tickFormat = targetXField.format;
    this.thickness(yAt, scale.y, false, false);
    this.thickness(xAt, nested ? scale.region : scale.x, true, true);
  } else {
    if (targetXField.interval && targetXField.format) yAt.tickFormat = targetXField.format;
    this.thickness(yAt, nested ? scale.region : scale.x, false, true);
    this.thickness(xAt, scale.y, true, false);
  }

  var innerSize = this.innerSize();
  //range 설정
  if (this.isVertical()) {
    //vertical 
    if (nested) {
      scale.region.range([0, innerSize.width]);
      scale.x.range([0, scale.region.bandwidth()]);
    } else {
      scale.x.range([0, innerSize.width]);
    }
    scale.y.range([innerSize.height, 0]); //reverse
  } else {
    //horizontal
    if (nested) {
      scale.region.range([0, innerSize.height]);
      scale.x.range([0, scale.region.bandwidth()]);
    } else {
      scale.x.range([0, innerSize.height]); //original
    }
    scale.y.range([0, innerSize.width]);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (_scale);

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_transition__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_util__ = __webpack_require__(1);




function _mark() {
  var that = this;
  var canvas = this.__execs__.canvas;
  var nested = this.isNested.call(this);
  var scale = this.__execs__.scale;
  var stacked = this.stacked();
  var vertical = this.isVertical();
  var color = this.color();
  var trans = Object(__WEBPACK_IMPORTED_MODULE_2_d3_transition__["b" /* transition */])().duration(this.transition().duration).delay(this.transition().delay);
  var yField = this.measureName();
  var hasZeroPoint = Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["h" /* zeroPoint */])(scale.y.domain());
  var label = this.label();
  var field = this.__execs__.field;
  var diffColor = this.showDiff();
  var isShowDiff = !nested && diffColor;

  var __local = function __local(selection) {
    var monoColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _fill = function _fill(d) {
      if (monoColor) return color[0];else return scale.color(d.data.key);
    };
    var tFormat = function tFormat(key) {
      var f = field.x.interval && field.x.format ? Object(__WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* timeFormat */])(field.x.format) : null; //FIXME: 다른 양식에서도 사용할 수 있도록 처리
      return f ? f(key) : key;
    };
    selection.each(function (d) {
      //local에 저장
      var x = void 0,
          y = void 0,
          w = void 0,
          h = void 0;
      var yValue = d.data.value[yField];
      var upward = yValue >= 0;
      if (stacked) {
        x = 0;
        y = (vertical ? upward : !upward) ? scale.y(d.data.value[yField + '-end']) : scale.y(d.data.value[yField + '-start']);
        w = nested ? scale.region.bandwidth() : scale.x.width;
        h = Math.abs(scale.y(d.data.value[yField + '-start']) - scale.y(d.data.value[yField + '-end']));
      } else {
        x = scale.x(d.data.key);
        y = (vertical ? upward : !upward) ? scale.y(yValue) : hasZeroPoint ? scale.y(0) : scale.y.range()[0];
        w = scale.x.bandwidth();
        h = Math.abs((hasZeroPoint ? scale.y(0) : scale.y.range()[0]) - scale.y(yValue));
      }
      var result = vertical ? { x: x, y: y + (upward ? 0 : 0.5), w: w, h: h, upward: upward } : { x: y + (upward ? 0.5 : 0), y: x, w: h, h: w, upward: upward };
      result.key = tFormat(d.data.key);
      result.color = _fill(d);
      result.text = Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["c" /* labelFormat */])(yValue);
      result.value = yValue;
      for (var k in result) {
        if (result.hasOwnProperty(k)) d[k] = result[k];
      }
    });
  };
  var __barInit = function __barInit(selection) {
    var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    selection.each(function (d) {
      var selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this);
      selection.style('cursor', 'pointer').style('fill', function (d) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).classed(Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff'))) return 'none';else return d.color;
      });
      if (vertical) {
        selection.attr('x', d.x).attr('y', d.upward ? d.y + d.h : d.y).attr('width', d.w).attr('height', 0);
      } else {
        selection.attr('x', d.upward ? d.x : d.x + d.w).attr('y', d.y).attr('width', 0).attr('height', d.h);
      }
    });
  };
  var __labelInit = function __labelInit(selection) {
    var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    selection.each(function (d) {
      var selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this);
      selection.style('pointer-events', 'none').text(d.text);
      if (vertical) {
        selection.attr('x', d.x + d.w / 2).style('text-anchor', 'middle');
        if (stacked) selection.attr('y', d.y + d.h).attr('dy', '1em');else if (d.upward) selection.attr('y', d.y + d.h).attr('dy', '-.25em');else selection.attr('y', d.y).attr('dy', '1em');
      } else {
        selection.attr('y', d.y + d.h / 2).attr('dy', '.35em');
        if (stacked) selection.attr('x', d.x + d.w / 2).attr('text-anchor', 'middle');else if (d.upward) selection.attr('x', d.x).attr('dx', '.5em');else selection.attr('x', d.x + d.w).attr('text-anchor', 'end').attr('dx', '-.1em');
      }
      that.styleFont(selection);
    });
  };
  var __bar = function __bar(selection) {
    selection.transition(trans).attr('x', function (d) {
      return d.x;
    }).attr('y', function (d) {
      return d.y;
    }).attr('width', function (d) {
      return d.w;
    }).attr('height', function (d) {
      return d.h;
    }).style('fill', function (d) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).classed(Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff'))) return 'none';else return d.color;
    });
  };
  var __label = function __label(selection) {
    var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    selection.each(function (d) {
      var selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this);
      if (vertical) {
        selection.transition(trans).attr('y', d.upward ? d.y : d.y + d.h);
      } else {
        if (stacked) selection.transition(trans).attr('x', d.x + d.w / 2).attr('text-anchor', 'middle');else selection.transition(trans).attr('x', d.upward ? d.x + d.w : d.x);
      }
      selection.text(d.text).style('fill', stacked ? '#fff' : d.color).style('visibility', label && (!diffColor || diffColor && selection.classed(Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff'))) ? 'visible' : 'hidden');
    });
  };

  var bar = void 0;
  var region = canvas.selectAll(this.regionName());
  bar = region.selectAll(this.nodeName()) //겹치는 경우 고려해서 바 거꾸로 넣기
  .data(function (d) {
    var target = d.children;
    return stacked ? target.slice().reverse() : target;
  }, function (d) {
    return d.data.key;
  });
  bar.exit().remove();
  var barEnter = bar.enter().append('g').attr('class', this.nodeName(true)).call(__local, nested ? false : this.mono()); //중복이 되지 않도록 enter와 update 데이터 업데이트 구분
  barEnter.append('rect').attr('class', Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar')).call(__barInit, vertical); //bar는 init이 따로 존재
  barEnter.append('text').attr('class', Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar')).call(__labelInit, vertical);
  if (nested && stacked) {
    barEnter.append('path').style('fill', function (d) {
      return d.color;
    }).style('visibility', 'hidden').attr('opacity', '0.5');
  }
  bar.call(__local, nested ? false : this.mono());
  bar = barEnter.merge(bar);
  bar.select('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).call(__bar, vertical);
  bar.select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).call(__label, vertical);

  if (isShowDiff) {
    // mono 막대간의 차이 보여주기
    var last = void 0;
    var strokeWidth = 1;
    var halfStrokeWidth = strokeWidth / 2;
    barEnter.append('rect').attr('class', Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff')).attr('stroke-dasharray', '5, 3').attr('stroke-width', strokeWidth);
    barEnter.append('text').attr('class', Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff'));
    bar.each(function (d, i, arr) {
      if (i > 0) {
        d.neighbor = last;
        var diff = { value: d.value - last.value, upward: d.upward };
        if (vertical) {
          diff.x = d.x;diff.w = d.w;
          if (diff.value > 0) {
            diff.y = d.y;
            diff.h = last.y - d.y;
          } else {
            diff.y = last.y;
            diff.h = d.y - last.y;
          }
        } else {
          diff.y = d.y;diff.h = d.h;
          if (diff.value > 0) {
            diff.x = last.w;
            diff.w = d.w - last.w;
          } else {
            diff.x = d.w;
            diff.w = last.w - d.w;
          }
        }
        diff.x += halfStrokeWidth;diff.y += halfStrokeWidth;
        diff.h -= strokeWidth;diff.w -= strokeWidth;
        diff.w = Math.max(strokeWidth * 2, diff.w);
        diff.h = Math.max(strokeWidth * 2, diff.h);
        diff.text = Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["c" /* labelFormat */])(diff.value, true);
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).each(function (d) {
          var selection = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).transition(trans);
          if (diff.value < 0) {
            if (vertical) {
              selection.attr('y', (d.upward ? d.y : d.y + d.h) - diff.h);
            } else {
              selection.attr('x', (d.upward ? d.x + d.w : d.x) + diff.w);
            }
          }
        });
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).transition(trans).style('fill', function (d) {
          return d.color = diffColor[(diff.value > 0 ? 'inc' : 'dec') + 'Fill'];
        });
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff', true)).datum(diff).attr('x', vertical ? diff.x + halfStrokeWidth : 0).attr('y', vertical ? d.upward ? d.y + d.h : d.y : diff.y + halfStrokeWidth).attr('width', vertical ? d.w - strokeWidth : 0).attr('height', vertical ? 0 : d.h - strokeWidth).call(__bar).style('stroke', diffColor[(diff.value > 0 ? 'inc' : 'dec') + 'Stroke']);
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff', true)).datum(diff).call(__labelInit, vertical).call(__label, vertical).style('fill', diffColor[(diff.value > 0 ? 'inc' : 'dec') + 'Fill']);
        d.diff = diff;
      } else {
        d.neighbor = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(arr[i + 1]).datum();
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).transition(trans).style(diffColor.neuFill);
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('diff', true)).remove();
      }
      last = d;
    });
  }

  if (nested && stacked) {
    //stack 차이 영역 
    var pathLocal = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["c" /* local */])();
    region.each(function (r, i, arr) {
      var neighbor = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(i < arr.length - 1 ? arr[i + 1] : arr[i - 1]).datum();
      var nds = neighbor.children;
      Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).selectAll(that.nodeName()).each(function (d) {
        var nd = nds.find(function (nd) {
          return nd.data.key === d.data.key;
        });
        d.neighbor = nd; //neighbor에 데이터 저장
      });
    });
    region.filter(function (d, i, arr) {
      return i < arr.length - 1;
    }).selectAll(that.nodeName()).select('path').style('fill', function (d) {
      return d.color;
    }).each(function (d) {
      d.diff = { value: d.neighbor.value - d.value };
      var parent = d.parent;
      var neighbor = d.neighbor;
      var neighborParent = neighbor.parent;
      var points = [];
      if (vertical) {
        //시계방향 순서로 지정
        points.push([d.x + d.w, d.y]);
        points.push([neighborParent.x + neighbor.x - parent.x, neighborParent.y - parent.y + neighbor.y]);
        points.push([points[1][0], points[1][1] + neighbor.h]);
        points.push([points[0][0], points[0][1] + d.h]);
      } else {
        points.push([d.x, d.y + d.h]);
        points.push([points[0][0] + d.w, points[0][1]]);
        points.push([neighborParent.x + neighbor.x + neighbor.w - parent.x, points[0][1] + neighborParent.y + neighbor.y - parent.y - d.y - d.h]);
        points.push([points[2][0] - neighbor.w, points[2][1]]);
      }
      var source = vertical ? [points[0], points[3]] : [points[0], points[1]];
      source = 'M' + source[0] + 'L' + (vertical ? source[0] : source[1]) + 'L' + source[1] + 'L' + (vertical ? source[1] : source[0]) + 'z';
      var target = points.map(function (point, i) {
        return (i === 0 ? 'M' : 'L') + point;
      }).join('') + 'z';
      pathLocal.set(this, { source: source, target: target });
    });

    bar.on('mouseenter.stacked', function (d) {
      bar.filter(function (t) {
        return t.data.key !== d.data.key;
      }).selectAll('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).transition().style('fill', '#b2c0d1');
      var neighbor = region.selectAll(that.nodeName()).filter(function (t) {
        return t.data.key === d.data.key;
      });
      if (!label) {
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).style('visibility', 'visible');
        neighbor.select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).style('visibility', 'visible');
      }
      neighbor.select('path').style('visibility', 'visible').attr('d', function () {
        var path = pathLocal.get(this);
        if (path) return path.source;
      }).interrupt().transition(trans).attr('d', function () {
        var path = pathLocal.get(this);
        if (path) return path.target;
      });
    }).on('mouseleave.stacked', function (d) {
      bar.filter(function (t) {
        return t.data.key !== d.data.key;
      }).selectAll('rect' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).transition().style('fill', function (d) {
        return d.color;
      });
      var neighbor = region.selectAll(that.nodeName()).filter(function (t) {
        return t.data.key === d.data.key;
      });
      if (!label) {
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).style('visibility', 'hidden');
        neighbor.select('text' + Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["a" /* className */])('bar', true)).style('visibility', 'hidden');
      }
      neighbor.select('path').interrupt().transition(trans).attr('d', function () {
        var path = pathLocal.get(this);
        if (path) return path.source;
      }).on('end', function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).style('visibility', 'hidden');
      });
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = (_mark);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default___ = __webpack_require__(2);


function _axis() {
  var that = this;
  var scale = this.__execs__.scale;
  var axisToggles = this.axis();
  var nested = this.isNested();
  var facet = this.facet();
  var orient = this.orient();
  var measures = this.measures();
  var grid = this.grid();
  var innerSize = this.innerSize();
  var aggregated = this.aggregated();
  var mixed = this.isMixed();
  var fieldObj = this.__execs__.field;

  var _axisScaleX = function _axisScaleX(axisToggle) {
    var targetField = fieldObj.region || fieldObj.x;
    axisToggle.field = targetField.field;
    var curAxis = that.axisDefault(nested ? scale.region : scale.x, axisToggle);
    if (axisToggle.orient === 'bottom') curAxis.y(scale.y.range()[0]);

    if (targetField.interval && targetField.format) {
      //FIXME: region 있으면 region으로
      curAxis.tickFormat(targetField.format);
    }
    return curAxis;
  };

  var _axisScaleY = function _axisScaleY(axisToggle) {
    var field = void 0;
    if (aggregated && fieldObj.y.field === __WEBPACK_IMPORTED_MODULE_0__default___["e" /* mixedMeasure */].field) field = '';else if (mixed) field = measures.map(function (d) {
      return d.field;
    }).join('-');else field = fieldObj.y.field;
    axisToggle.field = field;
    var curAxis = that.axisDefault(scale.y, axisToggle);
    curAxis.grid(grid).gridSize(axisToggle.orient === 'bottom' || axisToggle.orient === 'top' ? innerSize.height : innerSize.width);
    if (axisToggle.orient === 'bottom') curAxis.y((nested ? scale.region : scale.x).range()[1]);
    return curAxis;
  };

  var xAt = this.axisX();
  var yAt = this.axisY();
  if (this.isFacet()) {
    //horizontal 일 경우 top d1
    //vertical 일 경우 right d1
    var field = void 0;
    if (mixed) field = measures.map(function (d) {
      return d.field;
    }).join('-');else field = fieldObj.x.field;
    if (facet.orient === 'horizontal' && xAt) {
      xAt.field = field;
      xAt.orient = 'top';
      xAt.showDomain = false;
      this.axisDefault(scale.region, xAt);
    } else if (facet.orient === 'vertical' && yAt) {
      yAt.field = field;
      yAt.orient = 'right';
      yAt.showDomain = false;
      this.axisDefault(scale.region, yAt).x(innerSize.width);
    }
  } else {
    if (xAt) {
      if (orient === 'vertical') {
        _axisScaleX(xAt);
      } else {
        _axisScaleY(xAt);
      }
    }
    if (yAt) {
      if (orient === 'horizontal') {
        _axisScaleX(yAt);
      } else {
        _axisScaleY(yAt);
      }
    }
  }

  this.renderAxis();
}

/* harmony default export */ __webpack_exports__["a"] = (_axis);

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _legend() {
  var field = this.__execs__.field;
  if (this.mono() && (!field.region || this.isFacet())) {
    //mono 이면서 dimensions 1개인 경우 축 필요 없음
    return;
  }
  this.renderLegend('x');
}

/* harmony default export */ __webpack_exports__["a"] = (_legend);

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _region() {
  var nested = this.isNested.call(this);
  var scale = this.__execs__.scale;
  var stacked = this.stacked();
  var facet = this.facet();
  var vertical = this.isVertical();
  var isFacet = this.isFacet();
  var __regionLocal = function __regionLocal(d) {
    var xy = nested ? [scale.region(d.data.key), 0] : [0, 0];
    if (facet && !stacked && facet.orient === 'vertical') {
      xy.reverse();
    } else if (!vertical && facet.orient !== 'horizontal') {
      xy.reverse();
    }
    var x = xy[0];
    var y = xy[1];
    d.x = x;d.y = y;
  };

  this.renderRegion(__regionLocal, function (d) {
    return d;
  }, isFacet);
}

/* harmony default export */ __webpack_exports__["a"] = (_region);

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default___ = __webpack_require__(2);


function _facet() {
  var _this = this;

  var parent = this;
  var scale = this.__execs__.scale;
  var facet = this.facet();
  var canvas = this.__execs__.canvas;
  var mono = this.mono();
  var innerSize = this.innerSize();
  var dimensions = [this.dimensions()[0]];
  var measures = this.isMixed() ? [__WEBPACK_IMPORTED_MODULE_1__default___["e" /* mixedMeasure */]] : this.measures();
  var width = void 0,
      height = void 0;
  var settings = ['axisTitles', 'normalized', 'padding', 'orient', 'font', 'highlightColor', 'label', 'grid', 'tooltip'].map(function (d) {
    return { key: d, value: _this[d]() };
  });
  var hasX = this.axisX();
  var hasY = this.axisY();
  var _smallbar = function _smallbar(d, i, arr) {
    var smallBar = Object(__WEBPACK_IMPORTED_MODULE_0____["b" /* default */])().container(this).data(d).dimensions(dimensions).measures(measures).width(width).height(height).legend(false).zeroMargin(true) //마진 제거
    .aggregated(true) //선 처리 여부;
    .parent(parent); //부모 객체 던지기
    settings.forEach(function (d) {
      smallBar[d.key](d.value);
    });

    if (!mono) smallBar.color(scale.color(d.data.key));
    if (facet.orient === 'vertical') {
      if (hasX) smallBar.axis({ target: 'x', orient: 'bottom' }); //, showTitle: i === arr.length-1});
      if (hasY) smallBar.axis({ target: 'y', orient: 'left' });
    } else {
      if (hasX) smallBar.axis({ target: 'x', orient: 'bottom' });
      if (hasY) smallBar.axis({ target: 'y', orient: 'left' }); //showTitle: i === 0});
    }
    smallBar.render();
  };
  if (facet.orient === 'horizontal') {
    width = scale.region.bandwidth();
    height = innerSize.height;
  } else {
    width = innerSize.width;
    height = scale.region.bandwidth();
  }

  canvas.selectAll(this.regionName() + '.facet').each(_smallbar);
}

/* harmony default export */ __webpack_exports__["a"] = (_facet);

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _tooltip() {
  if (!this.tooltip() || this.isFacet()) return;
  var parent = this.parent();
  var mixed = this.isMixed();
  var field = this.__execs__.field;
  var isStacked = this.stacked() && this.isNested() && !this.isFacet();
  var isVertical = this.isVertical();
  var isShowDiff = this.showDiff() && !this.isNested();
  var key = function key(d, text) {
    return { name: 'key', value: text };
  };
  var value = function value(d, text) {
    var name = void 0;
    if (mixed) {
      name = d.data.key;
    } else if (parent && parent.isMixed()) {
      name = d.data.key;
    } else {
      name = field.y.field;
    }
    return { name: name, value: text };
  };

  var valueDiff = function valueDiff(d) {
    var nd = d.neighbor;
    var result = [{ name: (isShowDiff ? d : d.parent).data.key, value: d.text }, { name: (isShowDiff ? nd : nd.parent).data.key, value: nd.text }];
    if (isShowDiff) result.reverse();
    var diff = d.diff ? d.diff.value : nd.diff.value;
    result.push({ name: '증감', value: diff });
    return result;
  };
  var offset = function offset(d) {
    var x = 0,
        y = 0;
    if (isStacked) {
      x = Math.max(-d.x + d.neighbor.x + d.neighbor.w, d.w);
      if (isVertical) {
        if (d.neighbor.parent.x > d.parent.x) x += Math.abs(d.neighbor.parent.x - d.parent.x) - d.w;
      } else {
        var yDiff = d.neighbor.parent.y - d.parent.y;
        if (yDiff < 0) {
          //마지막일때
          x = d.w;
        } else {
          y += d.h + (yDiff - d.h) / 2;
        }
      }
    } else {
      x += d.w;
    }
    return { x: x, y: y };
  };
  var toggle = { key: key, offset: offset };
  if (isStacked || isShowDiff) {
    toggle.value = valueDiff;
    toggle.showDiff = true;
  } else {
    toggle.value = value;
  }
  this.renderTooltip(toggle);
}

/* harmony default export */ __webpack_exports__["a"] = (_tooltip);

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_transition__ = __webpack_require__(4);



function translate(selection, innerSize) {
  var isVertical = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isInit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  selection.attr('transform', function (d) {
    if (isVertical) {
      if (isInit) return 'translate(' + [innerSize.width, innerSize.height] + ')';
      return 'translate(' + [innerSize.width, d.y - 0.5] + ')';
    } else {
      if (isInit) return 'translate(' + [0, 0] + ')';
      return 'translate(' + [d.w + 0.5, 0] + ')';
    }
  });
}
function line(selection, innerSize) {
  var isVertical = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (isVertical) {
    selection.attr('x1', -innerSize.width);
  } else {
    selection.attr('y2', innerSize.height);
  }
}

function _annotation() {
  if (!this.annotation() || this.isFacet() || this.stacked()) return;
  var annotation = this.annotation();
  var that = this;
  var canvas = this.__execs__.canvas;
  var trans = Object(__WEBPACK_IMPORTED_MODULE_1_d3_transition__["b" /* transition */])().duration(this.transition().duration).delay(this.transition().delay);
  var innerSize = this.innerSize();
  var isVertical = this.isVertical();
  var isShowDiff = this.showDiff() && !this.isNested();

  if (canvas.select('.annotation-g').empty()) canvas.append('g').attr('class', 'annotation-g');
  var g = canvas.select('.annotation-g');
  var anno = g.selectAll('.annotation').data(this.nodes().data());
  anno.exit().remove();
  var annoEnter = anno.enter().append('g').attr('class', 'annotation').call(translate, innerSize, isVertical, true).style('pointer-events', 'none');
  annoEnter.append('text').style('fill', annotation.color);
  annoEnter.append('line').style('stroke', annotation.color).style('shape-rendering', 'crispEdges').call(line, innerSize, isVertical);
  anno = annoEnter.merge(anno).transition(trans).call(translate, innerSize, isVertical);
  if (isShowDiff) {
    anno.style('visibility', function (d, i, arr) {
      if (d.diff) {
        if (d.diff.value < 0) return 'visible';else if (i < anno.size() - 1 && Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(arr[i + 1]).datum().diff.value > 0) return 'visible'; //마지막 막대는 아니면서, 다음 막대가 diff > 0 일때 보임 
      } else {
        //첫번째 막대인 경우 다음 diff > 0 일때 보임 
        if (d.neighbor.diff.value > 0) return 'visible';
      }
      return 'hidden';
    });
  }

  anno.select('text').text(function (d) {
    return d.key;
  }).style('visibility', annotation.showLabel ? 'visible' : 'hidden').style('fill', annotation.color).each(function () {
    that.styleFont(this);
  });
  anno.select('line').transition(trans).style('stroke', annotation.color).call(line, innerSize, isVertical);
}

/* harmony default export */ __webpack_exports__["a"] = (_annotation);

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_axis__ = __webpack_require__(6);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function setVal(_val) {
  var val = Object.assign({}, _val);
  if (val.orient && val.orient === 'x') {
    //legacy : 기존에는 orient에 값 넘기는 경우 있었음
    val.target = val.orient;
    val.orient = 'bottom';
  } else if (val.orient && val.orient === 'y') {
    val.target = val.orient;
    val.orient = 'left';
  }

  var isHorizontal = val.target === 'x';
  if (!('showDomain' in val)) val.showDomain = true;
  if (!('showTicks' in val)) val.showTicks = true;
  if (!('showTitle' in val)) val.showTitle = true;
  if (!('orient' in val)) val.orient = isHorizontal ? 'bottom' : 'left'; // x축일 경우 기본 bottom;
  if (!('thickness' in val)) {
    val.thickness = isHorizontal ? __WEBPACK_IMPORTED_MODULE_0__modules_axis__["c" /* horizontalAxisThickness */] : __WEBPACK_IMPORTED_MODULE_0__modules_axis__["g" /* verticalAxisThickness */];
    val.thickness += val.tickPadding ? val.tickPadding : 0;
    val.thickness += val.showTitle ? __WEBPACK_IMPORTED_MODULE_0__modules_axis__["d" /* offsetThickness */] * 2 : 0;
    val.thickness += val.showTicks ? __WEBPACK_IMPORTED_MODULE_0__modules_axis__["d" /* offsetThickness */] : 0;
    val.defaultThickness = val.thickness;
  }

  return val;
}
function axis(_val) {
  var _this = this;

  var adding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  //axis 토글 {target, orient, thickness}
  //기본적으로 x,y 받고 axis가 많이 필요한 경우는 override 해서 y -> y1,y2 등으로 변환해야함(예. par-coords)
  if (!arguments.length) return this.__attrs__.axisToggle;
  var val = void 0;
  if (Array.isArray(_val)) {
    this.__attrs__.axisToggle = _val.map(setVal);
    _val.forEach(function (d) {
      return _this.__execs__.axis[d.target] = {};
    });
    return this;
  } else if (typeof _val === 'string') {
    val = { target: _val };
    val = setVal(val);
  } else if ((typeof _val === 'undefined' ? 'undefined' : _typeof(_val)) === 'object') {
    val = Object.assign({}, _val);
    val = setVal(val);
  }
  var findIndex = this.__attrs__.axisToggle.findIndex(function (d) {
    return d.target === val.target && d.orient === val.orient;
  });
  if (adding) {
    if (findIndex >= 0) {
      this.__attrs__.axisToggle.splice(findIndex, 1, val);
    } else {
      this.__attrs__.axisToggle.push(val); //__attrs__ 에는 존재 여부만 저장
    }
    if (!this.__execs__.axis[val.target]) this.__execs__.axis[val.target] = {}; //__setting에 공간 열어두기
  } else {
    if (findIndex >= 0) {
      this.__attrs__.axisToggle.splice(findIndex, 1);
    }
  }

  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (axis);

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["b"]; });



/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = axisTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = axisRight;
/* harmony export (immutable) */ __webpack_exports__["a"] = axisBottom;
/* harmony export (immutable) */ __webpack_exports__["b"] = axisLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(21);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return this.axis().find(function (d) {
    return d.target === 'x';
  });
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return this.axis().find(function (d) {
    return d.target === 'y';
  });
});

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports = [{"년도":2014,"월":1,"전기적요인":886,"기계적요인":367},{"년도":2014,"월":2,"전기적요인":803,"기계적요인":333},{"년도":2014,"월":3,"전기적요인":796,"기계적요인":329},{"년도":2014,"월":4,"전기적요인":730,"기계적요인":337},{"년도":2014,"월":5,"전기적요인":741,"기계적요인":352},{"년도":2014,"월":6,"전기적요인":692,"기계적요인":296},{"년도":2014,"월":7,"전기적요인":951,"기계적요인":299},{"년도":2014,"월":8,"전기적요인":852,"기계적요인":293},{"년도":2014,"월":9,"전기적요인":623,"기계적요인":276},{"년도":2014,"월":10,"전기적요인":718,"기계적요인":330},{"년도":2014,"월":11,"전기적요인":683,"기계적요인":332},{"년도":2014,"월":12,"전기적요인":970,"기계적요인":520},{"년도":2015,"월":1,"전기적요인":874,"기계적요인":453},{"년도":2015,"월":2,"전기적요인":801,"기계적요인":355},{"년도":2015,"월":3,"전기적요인":879,"기계적요인":435},{"년도":2015,"월":4,"전기적요인":729,"기계적요인":368},{"년도":2015,"월":5,"전기적요인":722,"기계적요인":353},{"년도":2015,"월":6,"전기적요인":702,"기계적요인":328},{"년도":2015,"월":7,"전기적요인":840,"기계적요인":346},{"년도":2015,"월":8,"전기적요인":824,"기계적요인":354},{"년도":2015,"월":9,"전기적요인":594,"기계적요인":316},{"년도":2015,"월":10,"전기적요인":625,"기계적요인":383},{"년도":2015,"월":11,"전기적요인":638,"기계적요인":399},{"년도":2015,"월":12,"전기적요인":752,"기계적요인":421}]

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_axis__ = __webpack_require__(6);

function axisDefault(scale, axisToggle) {
  var axisTitle = this.axisTitles().filter(function (d) {
    return d.target === axisToggle.target && (!d.field || d.field === axisToggle.field) && (!d.shape || d.shape === axisToggle.shape);
  });
  if (axisTitle.length > 0) axisTitle = axisTitle[0];else axisTitle = null;

  //TODO: format 넘겨올 경우 처리 해줘야함. 시간과 수치 포맷 구별해야함
  var curAxis = Object(__WEBPACK_IMPORTED_MODULE_0__modules_axis__["a" /* default */])();
  curAxis.scale(scale).target(axisToggle.target).field(axisToggle.field).orient(axisToggle.orient).title(axisTitle ? axisTitle.title : axisToggle.title).titleOrient(axisToggle.titleOrient).transition(this.transition());
  if (axisToggle.tickPadding !== undefined) curAxis.tickPadding(axisToggle.tickPadding);
  if (axisToggle.thickness !== undefined) curAxis.thickness(axisToggle.thickness);
  if (axisToggle.showTitle !== undefined) curAxis.showTitle(axisToggle.showTitle);
  if (axisToggle.showDomain !== undefined) curAxis.showDomain(axisToggle.showDomain);
  if (axisToggle.showTicks !== undefined) curAxis.showTicks(axisToggle.showTicks);
  this.axisExec(axisToggle.target, axisToggle.field, curAxis);
  return curAxis;
}

/* harmony default export */ __webpack_exports__["a"] = (axisDefault);

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function axisExec(target, field, axis) {
  //FIXME: 실제 그려야할 Axis object 저장하는데 이름을 target-field로 계속 진행해야할지 단일한 계열로 바꿔야 할지 고민
  if (!arguments.length) return this.__execs__.axis;
  this.__execs__.axis[target] = this.__execs__.axis[target] || {};
  this.__execs__.axis[target][field] = axis; //axis.x.field 형태
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (axisExec);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function axisTitle(name, title) {
  //__execs__의 axis만 변화
  var splited = name.split('.');
  var target = splited[0];
  var field = splited.length > 2 ? splited.slice(1).join('.') : splited[1];
  var titles = this.axisTitles();
  var exist = -1;
  var shape = void 0;
  if (target.includes('-')) {
    var _splited = target.split('-');
    target = _splited[0];
    shape = _splited.length > 2 ? _splited.slice(1).join('-') : _splited[1];
  }
  //TODO: y-line이나 y-bar 인 경우 고려
  for (var i = 0; i < titles.length; i++) {
    var t = titles[i];
    if (t.field === field && t.target === target && t.shape === shape) {
      exist = i;
      break;
    }
  }
  if (title) {
    //title이 있는 경우는 넣고 없는 경우는  뺀다.
    var result = { target: target, field: field, title: title, shape: shape };
    if (exist >= 0) titles.splice(exist, 1, result);else titles.push(result); //axisDefault에서 axisTitles를 뒤져보고 결정
  } else {
    titles.splice(exist, 1);
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (axisTitle);

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_util__ = __webpack_require__(1);



function renderAxis() {
  var _this = this;

  var canvas = this.__execs__.canvas;
  var axisObj = this.__execs__.axis;
  var _appendAxis = function _appendAxis(selection, axis, targetNum) {
    var cName = 'axis target-' + axis.target() + ' orient-' + axis.orient() + ' targetNum-' + targetNum;
    var axisSel = selection.selectAll(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])(cName, true)) // + '.x-' + axis.x() + '.y-' + axis.y())
    .data([targetNum]);
    axisSel.exit().remove();
    axisSel = axisSel.enter().insert('g', ':first-child').attr('class', Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])(cName)) //+ ' x-' + axis.x() + ' y-' + axis.y())
    .merge(axisSel).classed(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('active'), true);
    axis.render(axisSel);
  };
  var axisG = canvas.selectAll(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('axis', true));
  axisG.classed(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('active'), false);
  for (var target in axisObj) {
    if (axisObj.hasOwnProperty(target)) {
      (function () {
        var targetNum = 0;
        for (var field in axisObj[target]) {
          if (axisObj[target].hasOwnProperty(field)) {
            var axis = axisObj[target][field];
            if (axis.facet()) {
              canvas.selectAll(_this.regionName()).call(_appendAxis, axis, targetNum);
            } else {
              canvas.call(_appendAxis, axis, targetNum);
            }
          }
          targetNum += 1;
        }
        canvas.selectAll(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('axis target-' + target, true)).filter(function (d) {
          return d >= targetNum;
        }).remove(); //targetnum 보다 큰 축은 삭제
      })();
    }
  }
  axisG.filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).classed(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('active'));
  }).remove();

  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (renderAxis);

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_axis__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_util__ = __webpack_require__(1);



function thickness(at, scale) {
  var isHorizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isOrdinal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var tickNum = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;

  var hidden = this.__execs__.hidden;
  if (!(at && at.showTicks)) return;
  if (scale.invert && scale.domain()[0] instanceof Date) {
    //FIXME: scaleTime 그대로 사용할 경우 포매팅 없이 고정 배율 사용. 추후 수정 필요
    if (this.zoom()) at.thickness *= 1.35;
    return at.thickness;
  }
  var font = at.font || __WEBPACK_IMPORTED_MODULE_0__modules_axis__["b" /* defaultFont */];
  var tickFormat = at.tickFormat || (isOrdinal ? __WEBPACK_IMPORTED_MODULE_0__modules_axis__["f" /* tickFormatForOrdinal */] : Object(__WEBPACK_IMPORTED_MODULE_0__modules_axis__["e" /* tickFormatForContinious */])(scale.domain()));
  var ticks = isOrdinal ? scale.domain() : scale.ticks(tickNum);
  var max = -1;
  var isOver = false;
  var innerSize = this.innerSize();
  var step = isHorizontal ? innerSize.width / ticks.length * 0.9 : 0;
  var tick = hidden.selectAll(Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('tick', true)).data(tickFormat ? ticks.map(tickFormat) : ticks);
  tick = tick.enter().append('text').attr('class', Object(__WEBPACK_IMPORTED_MODULE_1__modules_util__["a" /* className */])('tick')).merge(tick).text(function (d) {
    return d;
  });
  this.styleFont(tick, font);
  tick.each(function () {
    var w = this.getBBox().width;
    if (w > max) max = w;
    if (w > step) isOver = true;
  });
  max = max * (isHorizontal ? 0.8 : 1) + __WEBPACK_IMPORTED_MODULE_0__modules_axis__["d" /* offsetThickness */] * (isHorizontal ? 1.5 : 1);

  if (at.tickPadding) max += at.tickPadding;
  if (at.showTitle) max += __WEBPACK_IMPORTED_MODULE_0__modules_axis__["d" /* offsetThickness */];
  if (at.thickness) max += __WEBPACK_IMPORTED_MODULE_0__modules_axis__["d" /* offsetThickness */];

  if (at.defaultThickness) {
    if (isOver && max > at.defaultThickness) {
      at.thickness = max; //+ (isHorizontal ? offsetThickness : 0);
    } else if (at.defaultThickness < at.thickness) {
      at.thickness = at.defaultThickness;
    }
  }

  if (at.target === 'x') {
    at.thickness = Math.min(at.thickness, this.height() * 0.5);
  } else {
    at.thickness = Math.min(at.thickness, this.width() * 0.8);
  }
  tick.remove();
  at.thickness = Math.round(at.thickness);
  return at.thickness;
}

/* harmony default export */ __webpack_exports__["a"] = (thickness);

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_daisy_chart_src_layouts_bar__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_fire_json__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_fire_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_fire_json__);



Object(__WEBPACK_IMPORTED_MODULE_0_daisy_chart_src_layouts_bar__["b" /* default */])().data(__WEBPACK_IMPORTED_MODULE_1__data_fire_json___default.a).name('bar').container('#daisy-example').dimensions(['년도']).measures([{ field: '전기적요인', op: 'mean' }, { field: '기계적요인', op: 'mean' }]).axis('x').axis('y').render();

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return conditions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectLinear___ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sortable___ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default___ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__munge__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scale__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mark__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__axis__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__legend__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__region__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__facet__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tooltip__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__annotation__ = __webpack_require__(113);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var orients = ['vertical', 'horizontal'];
var conditions = ['normal', 'count', 'mixed'];
var _attrs = {
  annotation: false,
  facet: false,
  normalized: false,
  mono: true, //mono 타입 사용시에 mono색상 사용여부
  orient: orients[0],
  padding: 0.05,
  stacked: false,
  showDiff: false,
  regionPadding: 0.1
};

var Bar = function (_sortableMixin) {
  _inherits(Bar, _sortableMixin);

  function Bar() {
    _classCallCheck(this, Bar);

    return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).call(this, _attrs));
  }

  return Bar;
}(Object(__WEBPACK_IMPORTED_MODULE_1__sortable___["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__rectLinear___["a" /* default */]));

function _bar() {
  var bar = new Bar();
  return bar;
}

function update() {
  // 데이터가 바뀐 경우

  // 데이터의 계산에 영향 주는 요소가 바뀐 경우

  // 다른 화면 요소가 바뀐 경우 
}

function measureName() {
  var measures = this.measures();
  var yField = void 0;
  if (this.condition() === conditions[2]) yField = __WEBPACK_IMPORTED_MODULE_2__default___["e" /* mixedMeasure */].field;else if (this.aggregated() && measures[0].field === __WEBPACK_IMPORTED_MODULE_2__default___["e" /* mixedMeasure */].field) yField = measures[0].field;else yField = measures[0].field + '-' + measures[0].op;
  return yField;
}

function dehighlight(selection) {
  selection.select('rect').style('fill', function (d) {
    return d.color;
  });
}

function highlight(selection, highlightColor) {
  selection.select('rect').style('fill', highlightColor);
}

function highlightFromLegend(legend) {
  if (this.isFacet()) this.highlightRegions(function (d) {
    return d.data.key === legend.key;
  });else this.highlightNodes(function (d) {
    return d.data.key === legend.key;
  });
}

function highlightToLegend(d) {
  var legend = this.__execs__.legend;
  legend.highlight(d.data.key);
}

function dehighlightToLegend(d) {
  var legend = this.__execs__.legend;
  legend.dehighlight(d.data.key);
}

function dehighlightFromLegend(legend) {
  if (this.isFacet()) this.dehighlightRegions(function (d) {
    return d.data.key === legend.key;
  });
  this.dehighlightNodes(function (d) {
    return d.data.key === legend.key;
  });
}

function isCount() {
  return this.condition() === conditions[1];
}

function isFacet() {
  return this.facet() && this.isNested() && !this.stacked();
}
function isMixed() {
  return this.condition() === conditions[2];
}

function isNested() {
  var dimensions = this.dimensions();
  var condition = this.condition();
  return dimensions.length === 2 || condition == conditions[2] && dimensions.length === 1;
}

function isVertical() {
  return this.orient() === orients[0];
}

function renderLayout() {
  //완벽히 처음부터 업데이트 
  this.reset();
  this.renderFrame();
  __WEBPACK_IMPORTED_MODULE_4__munge__["a" /* default */].call(this);
  __WEBPACK_IMPORTED_MODULE_5__scale__["a" /* default */].call(this); //TODO: thickness 확인 추가
  this.renderCanvas();
  __WEBPACK_IMPORTED_MODULE_7__axis__["a" /* default */].call(this);
  __WEBPACK_IMPORTED_MODULE_9__region__["a" /* default */].call(this);
  if (this.isFacet()) {
    __WEBPACK_IMPORTED_MODULE_10__facet__["a" /* default */].call(this);
  } else {
    __WEBPACK_IMPORTED_MODULE_6__mark__["a" /* default */].call(this);
  }
  __WEBPACK_IMPORTED_MODULE_8__legend__["a" /* default */].call(this);
  __WEBPACK_IMPORTED_MODULE_11__tooltip__["a" /* default */].call(this);
  __WEBPACK_IMPORTED_MODULE_12__annotation__["a" /* default */].call(this);
}

Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["f" /* setMethodFromDefaultObj */])(Bar, 'annotation', { showLabel: true, color: '#477cd2' }); //OVERRIDE: measure로 사용되는 필드 이름 자동 생성 
Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["f" /* setMethodFromDefaultObj */])(Bar, 'showDiff', { neuFill: '#c0ccda', incStroke: '#477cd2', incFill: '#40bbfb', decStroke: '#f06292', decFill: '#f06292' });

Bar.prototype.measureName = measureName; //OVERRIDE: measure로 사용되는 필드 이름 자동 생성 
Bar.prototype.renderLayout = renderLayout;
Bar.prototype.update = update;
Bar.prototype.highlight = highlight;
Bar.prototype.highlightFromLegend = highlightFromLegend;
Bar.prototype.highlightToLegend = highlightToLegend;
Bar.prototype.dehighlight = dehighlight;
Bar.prototype.dehighlightFromLegend = dehighlightFromLegend;
Bar.prototype.dehighlightToLegend = dehighlightToLegend;
Bar.prototype.isCount = isCount;
Bar.prototype.isFacet = isFacet;
Bar.prototype.isMixed = isMixed;
Bar.prototype.isNested = isNested;
Bar.prototype.isVertical = isVertical;

Object(__WEBPACK_IMPORTED_MODULE_3__modules_util__["g" /* setMethodsFromAttrs */])(Bar, _attrs);

/* harmony default export */ __webpack_exports__["b"] = (_bar);


/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return verticalAxisThickness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return horizontalAxisThickness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return offsetThickness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tickFormatForContinious; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tickFormatForOrdinal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_axis__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_format__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layouts_default___ = __webpack_require__(2);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var offsetThickness = 14;
var verticalAxisThickness = 18;
var horizontalAxisThickness = 18;
var tickFormatForOrdinal = __WEBPACK_IMPORTED_MODULE_5__util__["c" /* labelFormat */];
var targets = ['x', 'y'];
var orients = ['top', 'right', 'bottom', 'left'];
var SIPrefixFormat = Object(__WEBPACK_IMPORTED_MODULE_2_d3_format__["a" /* format */])('.2s');
var commaFormat = Object(__WEBPACK_IMPORTED_MODULE_2_d3_format__["a" /* format */])(',');
var defaultFont = {
  'font-family': 'sans-serif',
  'font-size': 11,
  'font-weight': 'normal',
  'font-style': 'normal'
};
var gridColor = '#eeeff1';
var zerocolor = '#aaa';
var defaultTickRotate = 45;
var smallModeThreshold = 300;
var _attrs = {
  autoTickFormat: true,
  autoRotate: true,
  color: '#4e5665',
  field: null,
  facet: null,
  font: defaultFont,
  format: null,
  grid: false,
  gridSize: 0,
  orient: orients[2],
  scale: null,
  showTitle: true,
  showDomain: true,
  showTicks: true,
  thickness: 40,
  target: targets[0],
  tickFormat: null,
  title: '',
  titleOrient: null,
  ticks: null,
  tickRotate: 0,
  tickSize: 0,
  tickPadding: 4,
  transition: null,
  x: 0,
  y: 0
};

var Axis = function Axis() {
  _classCallCheck(this, Axis);

  this.__attrs__ = JSON.parse(JSON.stringify(_attrs));
  this.__execs__ = { axis: null, canvas: null, rotated: false };
};

function _axis() {
  return new Axis();
}

function isHorizontal() {
  return this.orient() === 'bottom' || this.orient() === 'top';
}

function _generator() {
  var orient = this.orient();
  var scale = this.scale();
  var axis = void 0;

  if (orient === orients[0]) axis = Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["d" /* axisTop */])();else if (orient === orients[1]) axis = Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["c" /* axisRight */])();else if (orient === orients[3]) axis = Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["b" /* axisLeft */])();else axis = Object(__WEBPACK_IMPORTED_MODULE_1_d3_axis__["a" /* axisBottom */])();
  this.__execs__.axis = axis;

  if (scale) axis.scale(scale);
  if (this.transition()) {
    var trans = this.transition();
    this.__execs__.transition = Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["b" /* transition */])().duration(trans.duration).delay(trans.delay);
  }
}

function _grid(selection, zoomed) {
  if (this.grid() && this.gridSize() > 0) {
    var gridSize = this.gridSize();
    var _isHorizontal = this.isHorizontal();
    var orient = this.orient();
    var target = _isHorizontal ? 'y2' : 'x2';
    var sign = orient === 'left' || orient === 'top' ? 1 : -1;
    var scale = this.scale();
    var gridLineTransforms = [];
    selection.selectAll('.tick').each(function (d) {
      gridLineTransforms.push(scale(d));
    });
    var gridLine = selection.selectAll('.grid').data(gridLineTransforms);
    gridLine.exit().remove();
    var gridLineEnter = gridLine.enter().append('g').attr('class', 'grid');
    gridLineEnter.append('line').style('stroke', gridColor);
    gridLine = gridLineEnter.merge(gridLine);
    if (this.transition() && !zoomed) {
      gridLine = gridLine.transition(this.__execs__.transition);
    }
    gridLine.attr('transform', function (d) {
      return 'translate(' + (_isHorizontal ? [d + 0.5, 0] : [0, d - 0.5]) + ')';
    }).select('line').attr(target, sign * gridSize);
  }
}

function _overflow(selection) {
  var _this = this;

  /* overflow 시나리오
  ordinal 한 경우 -> 
    -> 일단 클리핑
    -> 가장 긴 녀석을 기준으로 5도 단위로 각도 변화 시키기-> 90도 까지 
   continous 한 경우 -> 
    -> 5도 단위로 각도 변화 시키기-> 90도 까지
  */

  var scale = this.scale();
  var orient = this.orient();
  var tickStepSize = function () {
    if (scale.bandwidth) {
      var bandwidth = scale.bandwidth();
      if (bandwidth === 0) return scale.step();
      return scale.bandwidth();
    } else {
      var ticks = scale.ticks();
      if (ticks.length > 1) {
        return Math.abs(scale(ticks[1]) - scale(ticks[0]));
      } else {
        return Math.abs(scale.range[scale.range().length - 1] - scale.range()[0]);
      }
    }
  }();
  var _generateId = function _generateId() {
    var prefix = 'axis-' + _this.target() + '-' + _this.orient() + '-';
    return Object(__WEBPACK_IMPORTED_MODULE_5__util__["b" /* getUniqueId */])(prefix);
  };

  var _clipPath = function _clipPath() {
    var defs = selection.select('defs');
    if (defs.empty()) {
      var _id = _generateId();
      defs = selection.append('defs');
      defs.append('clipPath').attr('id', _id).append('rect');
      selection.selectAll('.tick').attr('clip-path', 'url(#' + _id + ')');
    }
    var rectPos = {};
    var scaleDist = Math.abs(scale.range()[1] - scale.range()[0]);
    if (_this.isHorizontal()) {
      rectPos.width = scaleDist;
      rectPos.height = _this.thickness() - (_this.showTitle() ? _this.font()['font-size'] * 1.71 : 0);
      rectPos.x = -rectPos.width / 2;
      rectPos.y = orient === 'bottom' ? 0 : -rectPos.height;
    } else {
      rectPos.width = _this.thickness();
      rectPos.height = scaleDist;
      rectPos.x = orient === 'left' ? -rectPos.width : 0;
      rectPos.y = -rectPos.height / 2;
    }
    defs.select('clipPath').select('rect').datum(rectPos).attr('x', function (d) {
      return d.x;
    }).attr('y', function (d) {
      return d.y;
    }).attr('width', function (d) {
      return d.width;
    }).attr('height', function (d) {
      return d.height;
    });
  };
  var _hidden = function _hidden() {
    var showTicks = _this.showTicks();
    var isSmall = tickStepSize < _this.font()['font-size'] * (_this.isHorizontal() ? 1 : 0.72);
    selection.selectAll('.tick').style('visibility', isSmall && scale.bandwidth ? 'hidden' : showTicks ? 'inherit' : 'hidden');
  };
  var _rotate = function _rotate() {
    var tickPadding = _this.tickPadding();
    var tickRotate = _this.tickRotate();
    var isHorizontal = _this.isHorizontal();
    var isPositive = _this.orient() === 'right' || _this.orient() === 'top';
    var _rotateFunc = function _rotateFunc(_selection) {
      var _tickRotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tickRotate;

      var padding = void 0;
      if (isHorizontal) padding = [0, tickPadding / 2];else padding = [_selection.attr('x') * .71, 0];
      if (_this.transition()) _selection = _selection.transition().duration(180);
      _selection.attr('transform', 'translate(' + padding + ') rotate(' + _tickRotate * -1 + ')').attr('text-anchor', isHorizontal ? 'start' : 'end').attr('text-anchor', isPositive ? 'start' : 'end');
    };

    if (tickRotate !== 0) {
      selection.selectAll('.tick > text').call(_rotateFunc);
      _this.__execs__.rotate = true;
      return;
    } else if (_this.autoRotate()) {
      var tick = selection.selectAll('.tick');
      var isOver = false;

      tick.each(function () {
        var w = this.getBBox().width;
        if (Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["g" /* select */])(this).selectAll('text').classed(Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* className */])('rotated'))) w *= 1.25;
        if (tickStepSize < w) isOver = true;
      });
      if (isHorizontal) {
        if (isOver) {
          tick.selectAll('text').classed(Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* className */])('rotated'), true).call(_rotateFunc, defaultTickRotate);
        } else {
          var rotated = tick.selectAll('text' + Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* className */])('rotated', true)).classed(Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* className */])('rotated'), false);
          if (_this.transition()) rotated = rotated.transition().duration(180);
          rotated.attr('transform', '').attr('text-anchor', 'middle');
        }
      }
    }
  };
  _clipPath();
  _rotate();
  _hidden();
}

function tickFormatForContinious(domain) {
  if (typeof domain[0] === 'number' && domain[1] >= 100000 && Math.abs(domain[1] - domain[0]) >= 1000) return SIPrefixFormat; //axis.tickFormat(SIPrefixFormat);
  else return commaFormat;
}

function _format() {
  // _render 전에 포매팅 해야함

  var axis = this.__execs__.axis;
  var tickFormat = this.tickFormat();
  var scale = this.scale();
  if (tickFormat) {
    axis.tickFormat(tickFormat);
  } else if (this.autoTickFormat()) {
    if (scale.invert && scale.domain()[0] instanceof Date) return; //시간인 경우 포매팅 처리 하지 않음
    var domain = scale.domain();
    if (scale.invert && !scale.padding) {
      //autoFormat 적용
      axis.tickFormat(tickFormatForContinious(domain));
    } else {
      axis.tickFormat(function (d) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util__["c" /* labelFormat */])(d);
      });
    }
  }
}

function _preStyle(selection) {
  //TODO : tickSize와 font 설정
  var axis = this.__execs__.axis;
  var font = this.font();
  var scale = this.scale();
  axis.tickSize(this.tickSize()).tickPadding(this.tickPadding() + (this.isHorizontal() ? 4 : 2));
  if (this.ticks()) axis.ticks(this.ticks());else if (scale.invert) {
    var range = scale.range();
    var dist = Math.abs(range[1] - range[0]);
    if (dist <= smallModeThreshold / 2) axis.ticks(2);else if (dist <= smallModeThreshold) axis.ticks(5);
  }
  for (var k in font) {
    selection.style(k, k === 'font-size' ? font[k] + 'px' : font[k]);
  }
}

function _render(selection, zoomed) {
  var _this2 = this;

  var axis = this.__execs__.axis;
  if (selection.selectAll('.domain').size() === 0) {
    selection.attr('transform', 'translate(' + [this.x(), this.y()] + ')');
  }

  if (this.transition() && !zoomed) {
    selection.transition(this.__execs__.transition).attr('transform', 'translate(' + [this.x(), this.y()] + ')').call(axis).on('end', function () {
      _overflow.call(_this2, selection);
    });
  } else {
    selection.attr('transform', 'translate(' + [this.x(), this.y()] + ')').call(axis);
    _overflow.call(this, selection);
  }
}

function _style(selection) {
  var tick = selection.selectAll('.tick');
  tick.select('line').style('stroke', this.color());
  tick.select('text').style('fill', this.color());
  selection.select('.domain').style('stroke', this.color());
}

function _title(selection) {
  var that = this;
  var _textTransform = function _textTransform(selection) {
    if (that.isHorizontal()) {
      selection.attr('dy', orient === 'bottom' ? '-1em' : '.71em');
    } else {
      if (titleOrient === 'bottom' || titleOrient === 'top') {
        selection.attr('dy', titleOrient === 'bottom' ? '2em' : '-1em');
      }
    }
  };
  var _transform = function _transform(selection) {
    if (that.isHorizontal()) {
      var padding = 0; //that.tickPadding() + Math.max(0, that.tickSize());
      selection.attr('transform', 'translate(' + [halfPos, orient === 'bottom' ? that.thickness() - padding : -that.thickness() + padding] + ')');
    } else {
      if (titleOrient === 'bottom' || titleOrient === 'top') {
        selection.attr('transform', 'translate(' + [0, titleOrient === 'bottom' ? Object(__WEBPACK_IMPORTED_MODULE_3_d3_array__["f" /* max */])(scale.range()) : Object(__WEBPACK_IMPORTED_MODULE_3_d3_array__["j" /* min */])(scale.range())] + ')');
      } else {
        selection.attr('transform', 'translate(' + [that.thickness() * (orient === 'left' ? -1 : 1), halfPos] + ') ' + (orient === 'left' ? 'rotate(90)' : 'rotate(-90)'));
      }
    }
  };
  var title = this.title() || this.field();
  if (!title) return;
  title = title.localeCompare(__WEBPACK_IMPORTED_MODULE_6__layouts_default___["b" /* countMeasure */].field) === 0 ? __WEBPACK_IMPORTED_MODULE_6__layouts_default___["c" /* countMeasureTitle */] : title;
  if (!this.showTitle()) {
    selection.selectAll('.title').remove();
    return;
  }
  var orient = this.orient();
  var titleOrient = this.titleOrient() || orient;
  var scale = this.scale();
  var halfPos = (scale.range()[0] + scale.range()[1]) / 2;

  var titleSel = selection.selectAll('.title').data([title]);
  titleSel.exit().remove();
  var titleSelEnter = titleSel.enter().append('g').attr('class', 'title').call(_transform);
  titleSelEnter.append('text').attr('text-anchor', 'middle').style('font-weight', 'bold').style('fill', this.color()).call(_textTransform);

  titleSel = titleSelEnter.merge(titleSel);
  titleSel.select('text').text(title);
  if (this.transition()) {
    titleSel.transition(this.__execs__.transition).call(_transform);
  }
  selection.selectAll('path.domain').style('visibility', this.showDomain() ? 'visible' : 'hidden');
}

function _zero(selection, zoomed) {
  var scale = this.scale();
  if (scale.invert && Object(__WEBPACK_IMPORTED_MODULE_5__util__["h" /* zeroPoint */])(scale.domain())) {
    var gridSize = this.gridSize();
    var _isHorizontal2 = this.isHorizontal();
    var orient = this.orient();
    var target = _isHorizontal2 ? 'y2' : 'x2';
    var sign = orient === 'left' || orient === 'top' ? 1 : -1;
    var _scale = this.scale();
    var gridLineTransforms = [];
    selection.selectAll('.tick').filter(function (d) {
      return d === 0;
    }).each(function (d) {
      gridLineTransforms.push(_scale(d));
    });
    var gridLine = selection.selectAll('.zero.grid').data(gridLineTransforms);
    gridLine.exit().remove();
    var gridLineEnter = gridLine.enter().append('g').attr('class', 'grid zero');
    gridLineEnter.append('line').style('stroke', zerocolor);
    gridLine = gridLineEnter.merge(gridLine);
    if (this.transition() && !zoomed) {
      gridLine = gridLine.transition(this.__execs__.transition);
    }
    gridLine.attr('transform', function (d) {
      return 'translate(' + (_isHorizontal2 ? [d + 0.5, 0] : [0, d - 0.5]) + ')';
    }).select('line').attr(target, sign * gridSize);
  }
}

function facet(orient) {
  if (!arguments.length) return this.__attrs__.facet;
  if (orients.includes(orient)) this.__attrs__.facet = { orient: orient };else this.__attrs__.facet = { orient: orients[0] };
  return this;
}

function update() {}
function render(selection) {
  var zoomed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (selection) {
    this.__execs__.canvas = selection;
  } else if (this.__execs__.canvas) {
    selection = this.__execs__.canvas;
  } else {
    return;
  }
  _generator.call(this);
  _format.call(this);
  _preStyle.call(this, selection);
  _render.call(this, selection, zoomed);
  _style.call(this, selection);
  _grid.call(this, selection, zoomed);
  _zero.call(this, selection, zoomed);
  _title.call(this, selection);
}
Axis.prototype.facet = facet;
Axis.prototype.render = render;
Axis.prototype.update = update;
Axis.prototype.isHorizontal = isHorizontal;

Object(__WEBPACK_IMPORTED_MODULE_5__util__["g" /* setMethodsFromAttrs */])(Axis, _attrs);

/* harmony default export */ __webpack_exports__["a"] = (_axis);


/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return orders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sortByValue__ = __webpack_require__(104);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var orders = ['natural', 'ascending', 'descending'];
var _attrs = {
  sortByValue: orders[0]
};

var sortableMixin = function sortableMixin(Base) {
  var Sortable = function (_Base) {
    _inherits(Sortable, _Base);

    function Sortable(appendedAttrs) {
      _classCallCheck(this, Sortable);

      for (var k in _attrs) {
        appendedAttrs[k] = _attrs[k];
      }
      return _possibleConstructorReturn(this, (Sortable.__proto__ || Object.getPrototypeOf(Sortable)).call(this, appendedAttrs));
    }

    return Sortable;
  }(Base);
  Sortable.prototype.sortByValue = __WEBPACK_IMPORTED_MODULE_1__sortByValue__["a" /* default */];
  Object(__WEBPACK_IMPORTED_MODULE_0__modules_util__["g" /* setMethodsFromAttrs */])(Sortable, _attrs);
  return Sortable;
};

/* harmony default export */ __webpack_exports__["a"] = (sortableMixin);


/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default___ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axis__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axisX__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axisY__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axisDefault__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axisExec__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axisTitle__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__renderAxis__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__thickness__ = __webpack_require__(28);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var RectLinear = function (_Default) {
  _inherits(RectLinear, _Default);

  function RectLinear(appendedAttrs) {
    _classCallCheck(this, RectLinear);

    return _possibleConstructorReturn(this, (RectLinear.__proto__ || Object.getPrototypeOf(RectLinear)).call(this, appendedAttrs));
  }

  return RectLinear;
}(__WEBPACK_IMPORTED_MODULE_0__default___["d" /* default */]);

RectLinear.prototype.axis = __WEBPACK_IMPORTED_MODULE_1__axis__["a" /* default */];
RectLinear.prototype.axisX = __WEBPACK_IMPORTED_MODULE_2__axisX__["a" /* default */];
RectLinear.prototype.axisY = __WEBPACK_IMPORTED_MODULE_3__axisY__["a" /* default */];
RectLinear.prototype.axisDefault = __WEBPACK_IMPORTED_MODULE_4__axisDefault__["a" /* default */];
RectLinear.prototype.axisExec = __WEBPACK_IMPORTED_MODULE_5__axisExec__["a" /* default */];
RectLinear.prototype.axisTitle = __WEBPACK_IMPORTED_MODULE_6__axisTitle__["a" /* default */];
RectLinear.prototype.renderAxis = __WEBPACK_IMPORTED_MODULE_7__renderAxis__["a" /* default */];
RectLinear.prototype.thickness = __WEBPACK_IMPORTED_MODULE_8__thickness__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (RectLinear);

/***/ })

},[496]);


// WEBPACK FOOTER //
// examples.mixedBar.js